import { useMemo } from 'react';
import { demeterPageElementsApi } from '../../../Apis/Apis';
import { DemeterCommodity, DemeterMarket, DemeterPageElementModel, DemeterPageType, DemeterRegion, DemeterSubRegion } from '../../../Generated/Raven-Demeter';
import useApi from './useApiHook';

interface UsePageElementsApiProps {
    pageType?: DemeterPageType;
    market?: DemeterMarket;
    region?: DemeterRegion;
    subRegion?: DemeterSubRegion;
    commodity?: DemeterCommodity;
    language?: string;
    isPageElementExcluded?: (pageElement: DemeterPageElementModel) => boolean;
}

const usePageElementsApi = (props?: UsePageElementsApiProps): DemeterPageElementModel[] | undefined => {
    const [, , listDemeterPageElementsResponse] = useApi(() =>
        demeterPageElementsApi.listDemeterPageElementsCurrent(
            props?.pageType,
            props?.market,
            props?.region,
            props?.subRegion,
            props?.commodity,
            props?.language ?? 'en-US',
            false,
        ),
    );

    const pageElements = useMemo(() => {
        if (!listDemeterPageElementsResponse || !listDemeterPageElementsResponse.rows) {
            return undefined;
        }

        if (!props?.isPageElementExcluded) {
            return listDemeterPageElementsResponse.rows;
        }

        return listDemeterPageElementsResponse.rows.filter((element) => {
            if (props?.isPageElementExcluded && props.isPageElementExcluded(element)) {
                return false;
            }

            return true;
        });
    }, [listDemeterPageElementsResponse]);

    return pageElements;
};

export default usePageElementsApi;
